import React, { memo } from 'react';

const EmailUnreadIcon = memo(({ className = 'size-[60px]' }) => (
  <svg className={className} fill="none" preserveAspectRatio="none" viewBox="0 0 60 60">
    <g id="Group 2350">
      <circle cx="30" cy="30" fill="#F2F6FA" r="30" />
      <mask
        height="32"
        id="mask0_1_50"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="32"
        x="14"
        y="14"
      >
        <rect fill="#D9D9D9" height="32" width="32" x="14" y="14" />
      </mask>
      <g mask="url(#mask0_1_50)">
        <g id="mark_email_unread">
          <mask
            height="32"
            id="mask1_1_50"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'alpha' }}
            width="32"
            x="14"
            y="14"
          >
            <rect fill="#D9D9D9" height="32" width="32" x="14" y="14" />
          </mask>
          <g mask="url(#mask1_1_50)">
            <path
              d="M19.3333 40.6667C18.6 40.6667 17.9722 40.4056 17.45 39.8833C16.9278 39.3611 16.6667 38.7333 16.6667 38V22C16.6667 21.2667 16.9278 20.6389 17.45 20.1167C17.9722 19.5944 18.6 19.3333 19.3333 19.3333H32.8C32.7111 19.7778 32.6667 20.2222 32.6667 20.6667C32.6667 21.1111 32.7111 21.5556 32.8 22H19.3333L30 28.6667L34.8667 25.6333C35.1778 25.9222 35.5167 26.1722 35.8833 26.3833C36.25 26.5944 36.6333 26.7778 37.0333 26.9333L30 31.3333L19.3333 24.6667V38H40.6667V27.2C41.1778 27.0889 41.6556 26.9333 42.1 26.7333C42.5444 26.5333 42.9556 26.2889 43.3333 26V38C43.3333 38.7333 43.0722 39.3611 42.55 39.8833C42.0278 40.4056 41.4 40.6667 40.6667 40.6667H19.3333ZM39.3333 24.6667C38.2222 24.6667 37.2778 24.2778 36.5 23.5C35.7222 22.7222 35.3333 21.7778 35.3333 20.6667C35.3333 19.5556 35.7222 18.6111 36.5 17.8333C37.2778 17.0556 38.2222 16.6667 39.3333 16.6667C40.4444 16.6667 41.3889 17.0556 42.1667 17.8333C42.9444 18.6111 43.3333 19.5556 43.3333 20.6667C43.3333 21.7778 42.9444 22.7222 42.1667 23.5C41.3889 24.2778 40.4444 24.6667 39.3333 24.6667Z"
              fill="#61B8E7"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
));

EmailUnreadIcon.displayName = 'EmailUnreadIcon';

export default EmailUnreadIcon;
